// src/Components/Footer.js
import React from 'react';
import logo from '../../Assets/NipponSplashLogo.png';
import './Footer.css'; 

const Footer = () => {
  
  return (
    <footer className="footer">
      {/* <div></div> */}
      <p style={{ fontSize: 18, fontWeight: 'bold', marginTop: '10px', marginLeft: '100px' }}>
        {/* &copy; 2024 Nippon Paint (India) Pvt Ltd */}
      </p>
      <div className="logo">
        {/* <img src={logo} alt="Logo" className="logo-image" /> */}
      </div>
    </footer>
  );
};

export default Footer;
